// navigator.mediaSession is a page-wide singleton shared by the audio and video players: whichever
// played last owns it, and only the owner may touch its position and playback state.
let owner = null;

export function claimMediaSession(player) {
  owner = player;
}

export function ownsMediaSession(player) {
  return owner === player;
}

// True when `player` was the owner and no longer is.
export function releaseMediaSession(player) {
  if (owner !== player) return false;
  owner = null;
  return true;
}
